import React from 'react';
import {Spinner, Typography} from '@bonprix/design-system';

export default function CartItemPrice({
                                          formerPrice = null,
                                          summarizedPrice,
                                          deliverable = null,
                                          reduction = null,
                                          loading = false
                                      }) {
    let summarizedPriceColor = null;
    if (formerPrice) {
        summarizedPriceColor = 'sale';
    }

    if (!deliverable) {
        summarizedPriceColor = 'on-bg-low';
    }

    return (
        <>
            {formerPrice &&
                <div className="flex gap-1">
                    {reduction &&
                        <Typography variant="body1" color="sale">{reduction}</Typography>
                    }
                    <Typography variant="body1" color="on-bg-mid" strikeThrough>{formerPrice}</Typography>
                </div>
            }
            <Typography variant="h4" component="span" color={summarizedPriceColor}
                        strikeThrough={!deliverable}>{summarizedPrice}</Typography>
            {
                loading && (<div className="absolute bg-clr-white top-0 left-0 flex items-center justify-center h-full w-full">
                    <Spinner edgeLength='2.625rem' />
                </div>)
            }
        </>
    );

}
